const mediaItems = [
  {
    title: '竖屏滚动阅读',
    desc: '适配手机屏幕，上下滑动流畅翻页，单手操作轻松便捷',
    icon: 'ri-scroll-to-bottom-line',
    color: 'bg-primary-50 text-primary-600',
    duration: '推荐模式',
  },
  {
    title: '横屏双页模式',
    desc: '平板横屏展示双页，还原纸质漫画阅读体验',
    icon: 'ri-book-open-line',
    color: 'bg-accent-50 text-accent-600',
    duration: '平板专属',
  },
  {
    title: '夜间护眼模式',
    desc: '深色背景柔和光线，长时间阅读不伤眼',
    icon: 'ri-moon-line',
    color: 'bg-secondary-50 text-secondary-600',
    duration: '全天可用',
  },
  {
    title: '智能预加载',
    desc: '自动缓存后续章节，阅读不卡顿，翻页零等待',
    icon: 'ri-speed-up-line',
    color: 'bg-primary-50 text-primary-600',
    duration: '极速体验',
  },
  {
    title: '高清原画质',
    desc: '保留漫画原始画质，线条清晰色彩饱满，细节一览无余',
    icon: 'ri-hd-line',
    color: 'bg-accent-50 text-accent-600',
    duration: '超清呈现',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">阅读方式</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">多种<strong>在线免费阅读</strong>模式，随心选择最适合你的阅读体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200 transition-colors"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-4 ${item.color}`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-background-100 text-foreground-500 whitespace-nowrap">{item.duration}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}